/** @jsx jsx */
import { Box, Button, jsx } from 'theme-ui';
import { RichText } from 'prismic-reactjs';
import { MdLocalPhone } from 'react-icons/md';
import styles from './call-us-banner.style';
import bannerImg from '../../images/call-us-bg.svg';

const CallusBanner = (props: any) => {
	const { callUsBanner, callUsTitle, callUsButtonText } = props;
	return (
		<Box
			as="section"
			sx={{
				backgroundImage: `url(${
					callUsBanner && callUsBanner.url ? callUsBanner.url : bannerImg
				})`,
				...styles.banner,
			}}
		>
			<Box as="header" sx={styles.bannerContent}>
				{RichText.render(callUsTitle)}
				{/* <Heading as="h2" dangerouslySetInnerHTML={{ __html: title }} /> */}
				<Button variant="white">
					<MdLocalPhone />{' '}
					{callUsButtonText ? RichText.asText(callUsButtonText) : 'Call Us'}
				</Button>
			</Box>
		</Box>
	);
};

export default CallusBanner;
